import React from 'react';
import './App.scss';

// MSAL imports
import AppRoutes from './components/appRoutes';


function App() {

  return (
      <AppRoutes />
  );
}

export default App;

